import { render, staticRenderFns } from "./CartCoupon.vue?vue&type=template&id=67858c4a&scoped=true"
import script from "./CartCoupon.vue?vue&type=script&lang=js"
export * from "./CartCoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67858c4a",
  null
  
)

export default component.exports